<div
  [className]="attachmentClass()"
  [attr.aria-label]="'cl_chat.fileLabels.generic' | translate: { extension: attachmentExtension() }"
>
  <div class="download-folder">
    <div class="download-fold">
      <div class="download-foldover foldover-border"></div>
      <div class="download-foldover foldover-background"></div>
    </div>
    <div class="download-extension" [ngStyle]="{ 'font-size': fontSize() }">
      {{ attachmentExtension() }}
    </div>
  </div>
</div>
